// extracted by mini-css-extract-plugin
export default {"app":"app_OXwE","cursor":"cursor_Gwnb","pointer":"pointer_Sj3w","stalker":"stalker_efM4"};